import { useState, useEffect, useRef } from 'react';
import { X, Globe } from 'lucide-react';

const CITIES = ['London', 'Dubai', 'Singapore', 'New York', 'Amsterdam', 'Zurich', 'Hong Kong', 'Paris', 'Frankfurt', 'Milan', 'Tokyo', 'Sydney', 'Toronto', 'Miami', 'Madrid', 'Stockholm', 'Riyadh', 'Doha', 'Sao Paulo', 'Abu Dhabi', 'Johannesburg', 'Brussels', 'Geneva', 'Munich', 'Vienna', 'Copenhagen'];
const TYPES = [
  'requested a private demo', 'booked a strategic consultation', 'requested architecture session',
  'downloaded the enterprise whitepaper', 'requested enterprise deployment info', 'booked a digital meeting',
  'requested a workforce design session', 'submitted an inquiry', 'requested a pilot consultation',
  'booked an executive discovery call',
];
const COMPANIES = ['a family office', 'a holding group', 'a law firm', 'a financial institution', 'a healthcare group', 'a real estate group', 'a private equity firm', 'an enterprise operator', 'a luxury brand', 'a trading company', 'an executive office'];

function randomItem(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

function generateNotif() {
  return { city: randomItem(CITIES), type: randomItem(TYPES), company: randomItem(COMPANIES), minutes: Math.floor(Math.random() * 25) + 2 };
}

export default function LiveActivityTicker() {
  const [notif, setNotif] = useState(generateNotif());
  const [visible, setVisible] = useState(false);
  const dismissedRef = useRef(false);
  const [dismissed, setDismissed] = useState(false);

  const handleDismiss = () => {
    dismissedRef.current = true;
    setDismissed(true);
  };

  useEffect(() => {
    const t1 = setTimeout(() => { if (!dismissedRef.current) setVisible(true); }, 5000);

    const interval = setInterval(() => {
      if (dismissedRef.current) return;
      setVisible(false);
      setTimeout(() => {
        if (dismissedRef.current) return;
        setNotif(generateNotif());
        setVisible(true);
      }, 600);
    }, 8000);

    return () => { clearTimeout(t1); clearInterval(interval); };
  }, []);

  if (dismissed) return null;

  return (
    <div className={`fixed bottom-6 right-6 z-40 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
      data-testid="live-activity-ticker">
      <div className="glass-card border-aurocle-gold/15 p-4 max-w-xs shadow-[0_8px_32px_rgba(0,0,0,0.5)] relative overflow-hidden">
        <div className="absolute inset-0 flash-sweep pointer-events-none" />
        <button onClick={handleDismiss} className="absolute top-1 right-1 text-aurocle-text-secondary hover:text-aurocle-text transition-colors p-2 z-20 bg-aurocle-surface/50 hover:bg-aurocle-surface" data-testid="ticker-close" aria-label="Dismiss">
          <X size={12} />
        </button>
        <div className="relative z-10 flex items-start gap-3">
          <div className="w-8 h-8 flex items-center justify-center border border-aurocle-gold/20 shrink-0 mt-0.5">
            <Globe size={12} className="text-aurocle-gold" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 breathe" />
              <span className="text-[10px] font-mono text-emerald-400 uppercase tracking-wider">Live</span>
            </div>
            <p className="text-xs text-aurocle-text leading-relaxed">
              Someone from <span className="text-aurocle-gold font-medium">{notif.company}</span> in <span className="text-aurocle-gold font-medium">{notif.city}</span> {notif.type}
            </p>
            <p className="text-[10px] font-mono text-aurocle-text-secondary mt-1.5">{notif.minutes} minutes ago</p>
          </div>
        </div>
      </div>
    </div>
  );
}
